__turbopack_context__.v({
  "appBar": "MethodDetail-module-scss-module__kT5p7q__appBar",
  "appBarTitle": "MethodDetail-module-scss-module__kT5p7q__appBarTitle",
  "counter": "MethodDetail-module-scss-module__kT5p7q__counter",
  "detailSections": "MethodDetail-module-scss-module__kT5p7q__detailSections",
  "footer": "MethodDetail-module-scss-module__kT5p7q__footer",
  "mobileMethodDetail": "MethodDetail-module-scss-module__kT5p7q__mobileMethodDetail",
  "scrollContent": "MethodDetail-module-scss-module__kT5p7q__scrollContent",
  "section": "MethodDetail-module-scss-module__kT5p7q__section",
  "sectionText": "MethodDetail-module-scss-module__kT5p7q__sectionText",
  "sectionTitle": "MethodDetail-module-scss-module__kT5p7q__sectionTitle",
});
